import { Injectable } from "@angular/core";
import { PlatformAdapter } from "./platform.adapter";

@Injectable({ providedIn: "root" })
export class BrowserPlatformAdapter implements PlatformAdapter {
  readonly isNative = false;
  readonly platformId = "browser" as const;
  readonly hasLocalSqlite = false;
  readonly hasUsbSerial = false;
  readonly hasUdp = false;
  readonly hasGamepad = false;
  readonly hasNativeZip = false;

  syncWebSocketUrl(): string {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${proto}//${window.location.host}/ws/sync`;
  }

  async postJson(
    url: string,
    headers: Record<string, string>,
    body: unknown
  ): Promise<{ status: number; body: unknown }> {
    const res = await fetch(url, { method: "POST", headers, body: JSON.stringify(body) });
    return { status: res.status, body: await res.json().catch(() => null) };
  }

  async getJson(url: string, headers: Record<string, string>): Promise<{ status: number; body: unknown }> {
    const res = await fetch(url, { headers });
    return { status: res.status, body: await res.json().catch(() => null) };
  }
}
